import { useState } from 'react';
import { Formik } from 'formik';
import { ErrorModal, Modal, TextArea, CheckBox } from 'components';
import { withStore } from 'store';
import { deleteGiftTable as deleteGiftTableAction } from 'store/actions/giftTable';
import { useWindowSize } from 'hooks';
import { initialValues, schema } from './config';
import { formatter } from './formatter';

function DeleteTableFlux({
  show,
  onClose = () => {},
  dispatch,
  selectedTable,
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const [, { isMobile }] = useWindowSize();

  const handleClose = () => {
    onClose(false);
    setCurrentStep(1);
  };

  const handleSubmit = (values) => {
    const formattedValues = formatter(values);
    dispatch(
      deleteGiftTableAction({
        onSuccess: handleClose,
        ...formattedValues,
        id: selectedTable,
      })
    );
  };

  const modalType = isMobile ? 'single' : 'action';

  const renderStep1 = () => (
    <ErrorModal
      show={show}
      title=""
      titleHeader="Cancelar mesa"
      titleHeaderClassName="col-md-12 offset-md-3"
      actionLabel="Aceptar"
      onAction={() => setCurrentStep(2)}
      onClose={handleClose}
      closeLabel = 'Cancelar'
      type={modalType}
      subtitle={
        <p className="text-center">
          Estas a punto de cancelar tu mesa de regalos.
          <br />
          ¿Estas seguro que quieres hacerlo?
        </p>
      }
    />
  );

  const renderStep2 = (formikProps) => (
    <Modal
      show={show}
      title="Motivo de la cancelación"
      titleClassName={isMobile ? 'text-center' : ''}
      actionLabel="Enviar"
      type={modalType}
      onClose={handleClose}
      onSubmit={formikProps.handleSubmit}
      className="pt-4 pb-1"
    >
      <TextArea name="motive" containerClassName="p-0" />
      <CheckBox
        name="contactMe"
        label="Sears puede contactarme."
        containerClassName="p-0"
      />
    </Modal>
  );

  const RENDER_STEPS = (formikProps) => [
    renderStep1(formikProps),
    renderStep2(formikProps),
  ];

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => RENDER_STEPS(formikProps)[currentStep - 1]}
    </Formik>
  );
}

export default withStore({
  mapStateToProps: (state) => ({
    giftTable: state.giftTable.giftTable,
  }),
})(DeleteTableFlux);
